import { Component, OnInit } from '@angular/core';
import { ModalContent, ModalRef } from "../../../modal-ref";
import { SafePipe } from '../../../../shared/pipes/safe.pipe';
import { AsyncPipe } from '@angular/common';


@Component({
    selector: 'app-title-and-content-modal',
    templateUrl: './title-and-content-modal.component.html',
    styleUrls: ['./title-and-content-modal.component.scss'],
    imports: [AsyncPipe, SafePipe]
})
export class TitleAndContentModalComponent implements OnInit, ModalContent {

  /**
   * Link to modal window
   */
  public modal: ModalRef;

  constructor() {
  }

  ngOnInit() {
  }

}

